







































import Vue from 'vue'
import PageTitle from '@/components/page-title/PageTitle.vue'
import WeSlogan from '@/components/we-slogan/WeSlogan.vue'
import RecentWork from '@/components/recent-work/RecentWork.vue'
import DarkBar from '@/components/dark-bar/DarkBar.vue'
import Team from '@/components/team/Team.vue'

export default Vue.extend({
  components: {
    PageTitle,
    WeSlogan,
    RecentWork,
    DarkBar,
    Team
  }
})
